import React from 'react';
import ImageComponent from 'atoms/Image';
import { ButtonComp } from 'atoms/Buttons';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { useHistory } from 'react-router-dom';

const TwoColumnCardComponent = ({ data }) => {
  const history = useHistory();

  return (
    <div className='card-banner'>
      <div className='card-row'>
        {data.map((cardInfo, index) => {
          const { ctaButton, description, headline } = cardInfo?.fields;
          const { content } = description?.content[0];
          const { buttonText } = ctaButton?.fields;
          return (
            <div className={`card-container ${index === 0 && 'container-margin'}`}>
              <div className='strip-icon'>
                <ImageComponent srcFile={IMAGE_PATH?.StripesIcon} />
              </div>
              <span className='card-heading'>{headline}</span>
              {content?.map(desc => (
                <span className='card-short-desc'>{desc?.value}</span>
              ))}

              {ctaButton && (
                <span className='find-more-btn'>
                  <ButtonComp
                    className='button transparent-btn black-border'
                    onClick={() =>
                      ctaButton?.fields?.url
                        ? history.push(ctaButton?.fields?.url)
                        : window.open(ctaButton?.fields?.externalUrl, '_blank')
                    }
                    data-testid='btn-two-coloumn'
                  >
                    {buttonText}
                  </ButtonComp>
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TwoColumnCardComponent;
